<template>
    <div class="repeater">
        <draggable
            :list="rows"
            handle=".moveButton"
            ghost-class="ghost"
        >
            <transition-group tag="div">
                <RepeaterRow
                    v-for="row in rows"
                    :key="row.id"
                    @removeRow="removeRow(row)"
                >
                    <template v-slot>
                        <slot :row="row" />
                    </template>
                </RepeaterRow>
            </transition-group>
        </draggable>
        <div class="buttonHolder flex flex-wrap justify-end">
            <AppButton
                :label="buttonLabel"
                :small="true"
                @click="addRow"
            >
                <template v-slot:icon>
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
                </template>
            </AppButton>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import AppButton from '../ui/AppButton.vue';
import RepeaterRow from './RepeaterRow.vue';

export default {
    components: {
        draggable,
        AppButton,
        RepeaterRow,
    },
    props: {
        rows: {
            type: Array,
            required: true,
        },
        buttonLabel: {
            type: String,
            default: 'Add row',
        },
    },
    methods: {
        addRow() {
            this.$emit('addRow', { id: Date.now() });
        },
        removeRow(row) {
            const index = this.rows.indexOf(row);
            if (index !== -1) {
                this.$emit('removeRow', index);
            }
        },
    },
};
</script>

<style lang="postcss" scoped>
.repeater,
.repeaterRow {
    border: 1px solid var(--borderColor);
    padding: 25px;
    border-radius: var(--borderRadius);
    @media (--smallDesktop) {
        padding: 20px;
    }
    @media (--laptop) {
        padding: 14px;
    }
}
.repeaterRow {
    @media (--laptop) {
        padding: 25px 20px;
    }
}
.repeater {
    background-color: var(--grey100);
}
</style>
